import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LegalPage from "./pages/LegalPage";
import { TrackPageviews } from "./components/TrackPageviews";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import VehicleDetail from "@/pages/VehicleDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <TrackPageviews />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vettura/:id" element={<VehicleDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
          <Route path="/cookie-policy" element={<LegalPage type="cookie" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
